import { Module } from 'vuex-smart-module';
import ReportsMutualsActions from './actions';
import ReportsMutualsGetters from './getters';
import ReportsMutualsMutations from './mutations';
import ReportsMutualsState from './state';

export default new Module({
  state: ReportsMutualsState,
  mutations: ReportsMutualsMutations,
  actions: ReportsMutualsActions,
  getters: ReportsMutualsGetters,
});
